var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"my-2 py-0",attrs:{"cols":"12","sm":"6"}},[_c('v-card',{staticClass:"pa-2 grey lighten-5",attrs:{"flat":""}},[_vm._v(" "+_vm._s(_vm.texte)+" : "),_c('b',[_vm._v(_vm._s(_vm.valeur))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }